// Central place for nav/footer config + site-wide copy snippets.
export const NAV_LINKS = [
  { to: "/", label: "Home", key: "home" },
  { to: "/about", label: "About", key: "about" },
  { to: "/speaking", label: "Speaking", key: "speaking" },
  { to: "/advisory", label: "Advisory", key: "advisory" },
  { to: "/writing", label: "Writing", key: "writing" },
  { to: "/contact", label: "Contact", key: "contact" },
];

export const SITE = {
  brand: "Rakia Finley",
  brandShort: "Rakia Finley",
  email: "rakia@coppervine.io",
  location: "Washington, DC",
  firmUrl: "https://coppervine.io",
  firmName: "Copper & Vine Studio",
  twitter: "",
  linkedin: "https://www.linkedin.com/in/rakiafinley/",
};

// Rakia Finley's photography — hosted locally under /public/images/.
// Replace files in /app/frontend/public/images/ to swap.
export const IMAGES = {
  heroPortrait: "/images/rakia-hero.jpg",
  aboutPortrait: "/images/rakia-about.jpg",
  speakingPortrait: "/images/rakia-speaking.jpg",
  advisoryPortrait: "/images/rakia-advisory.jpg",
};
